import { useCalcDocContentPaddingTop } from '@/hooks/useCalcDocContentPaddingTop';
import { useCalcNotificationHeight } from '@/hooks/useCalcNotificationHeight';
import React from 'react';

export function useDocAnchorPosition(navbarHeight: number): React.CSSProperties {
  const notificationHeight = useCalcNotificationHeight();
  const docPaddingTop = useCalcDocContentPaddingTop();

  return React.useMemo<React.CSSProperties>(() => {
    return {
      top: navbarHeight + docPaddingTop,
      height: `calc(100vh - ${navbarHeight + docPaddingTop + notificationHeight}px)`,
    };
  }, [docPaddingTop, navbarHeight, notificationHeight]);
}
